import React, { useEffect, useState } from "react";
import axios from "axios";

const AutorizarCheckpointModelo = () => {
  const [perguntas, setPerguntas] = useState([]);
  const [autorizadas, setAutorizadas] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const clienteId = localStorage.getItem("cliente_id");

  useEffect(() => {
    if (!clienteId) return;

    const carregarPerguntas = async () => {
      try {
        const todas = await axios.get("/api/checkpoints_modelo/");
        const ativas = await axios.get(`/api/checkpoints_autorizados/${clienteId}`);
        const autorizadasIds = ativas.data.map(p => Number(p.checkpoint_modelo_id));
        setPerguntas(todas.data);
        setAutorizadas(autorizadasIds);
      } catch (error) {
        console.error("Erro ao carregar perguntas:", error);
      } finally {
        setIsLoading(false);
      }
    };

    carregarPerguntas();
  }, [clienteId]);

  const toggleAutorizacao = async (perguntaId) => {
    const idNum = Number(perguntaId);
    console.log("➡️ Clicado:", idNum);
    console.log("✔️ Autorizadas atuais:", autorizadas);

    try {
      const jaAutorizada = autorizadas.includes(idNum);

      if (jaAutorizada) {
        await axios.delete(`/api/checkpoints_autorizados/${clienteId}/${idNum}`);
        setAutorizadas(autorizadas.filter(id => id !== idNum));
      } else {
        await axios.post(`/api/checkpoints_autorizados`, {
          cliente_id: clienteId,
          checkpoint_modelo_id: idNum,
        });
        setAutorizadas([...autorizadas, idNum]);
      }
    } catch (error) {
      console.error("Erro ao atualizar autorização:", error);
    }
  };

  return (
    <div className="form-wrapper">
      <h2 className="form-title">Autorizar Perguntas de CheckPoint</h2>

      {isLoading ? (
        <p style={{ color: "gray" }}>Carregando perguntas...</p>
      ) : perguntas.length === 0 ? (
        <p style={{ color: "red" }}>Nenhuma pergunta disponível.</p>
      ) : (
        <table className="tabela" style={{ fontSize: "0.9rem" }}>
          <thead style={{ backgroundColor: "#156082", color: "white" }}>
            <tr>
              <th style={{ textAlign: "left", width: "25%" }}>Categoria</th>
              <th style={{ textAlign: "left" }}>Pergunta</th>
              <th style={{ textAlign: "center", width: "10%" }}>Autorizada</th>
            </tr>
          </thead>
          <tbody>
            {perguntas.map((p) => {
              const idNum = Number(p.id);
              return (
                <tr key={idNum}>
                  <td>{p.categoria}</td>
                  <td>{p.pergunta}</td>
                  <td style={{ textAlign: "center" }}>
                    <input
                      type="checkbox"
                      checked={autorizadas.includes(idNum)}
                      onChange={() => toggleAutorizacao(idNum)}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default AutorizarCheckpointModelo;
